import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import DashboardIndicatorsContainer from './DashboardIndicatorsContainer';
import { useQueryWithSimpleErrorHandling } from 'hooks';
import { DASHBOARD_INDICATORS_QUERY } from '../queries';
import { FakeText } from '@totalsoft/rocket-ui';

const DashboardContainer = ({ userId, groupName, dashboardId }) => {
  const selectedLanguage = i18n.language;

  const { data, loading } = useQueryWithSimpleErrorHandling(DASHBOARD_INDICATORS_QUERY, {
    variables: {
      userId: userId,
      groupName,
      dashboardId: dashboardId,
      lang: selectedLanguage
    },
    fetchPolicy: 'no-cache'
  });

  if (loading) {
    return <FakeText lines={10} onPaper />;
  }

  return data?.dashboardIndicators ? <DashboardIndicatorsContainer indicators={data.dashboardIndicators} /> : null;
};

DashboardContainer.propTypes = {
  userId: PropTypes.number.isRequired,
  groupName: PropTypes.string.isRequired,
  dashboardId: PropTypes.number
};

export default DashboardContainer;
